var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBanner)?_c('div',{staticClass:"adbox"},[_c('a',{attrs:{"href":`${_vm.source.url}${_vm.source.anchor}`,"target":_vm.source.action},on:{"click":function($event){return _vm.$emit('click', _vm.source)}}},[_c('img',{attrs:{"src":_vm.source.img,"alt":_vm.source.alt}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }